module.exports = __webpack_public_path__ + "static/media/5222.f7152ed0.jpg";